module.exports = __webpack_public_path__ + "static/media/thumb_sejong_503x503.6cc9e327.jpg";